import { Link } from "react-router-dom";

interface Stat {
  value: string;
  label: string;
}

const STATS: Stat[] = [
  { value: "1,200+", label: "收录影视作品" },
  { value: "36", label: "覆盖国家与地区" },
  { value: "98%", label: "资讯更新时效" },
  { value: "24h", label: "内容动态追踪" },
];

export default function SiteIntro() {
  return (
    <section className="relative w-full overflow-hidden rounded-lg bg-primary-950">
      <div className="grid grid-cols-1 items-center gap-8 p-6 md:p-10 lg:grid-cols-2 lg:gap-12">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-medium text-accent-300">
            <i className="ri-sparkling-line"></i>
            关于星空传媒
          </span>
          <h2 className="mt-4 font-heading text-2xl font-extrabold text-white md:text-3xl">
            让每一次发现，都从一颗星开始
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-primary-100 md:text-base">
            星空传媒是一个面向影视爱好者的内容聚合平台。我们聚合最新电视剧、电影与综艺内容，提供作品详情、分类筛选、内容检索与相关推荐，帮助你更高效地找到想看的内容，也更快地了解影视行业的最新动态。
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <Link
              to="/category/tv"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-accent-600 cursor-pointer"
            >
              <i className="ri-compass-3-line text-base"></i>
              开始浏览内容
            </Link>
            <Link
              to="/news"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-white/30 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-white/10 cursor-pointer"
            >
              查看影视资讯
            </Link>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          {STATS.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg bg-primary-900/70 p-5 text-center"
            >
              <p className="font-heading text-2xl font-extrabold text-accent-400 md:text-3xl">
                {stat.value}
              </p>
              <p className="mt-1 text-xs text-primary-200 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}